import { action, makeObservable, observable } from 'mobx';
import { SocAndBalancing } from 'src/integration/types/SocAndBalancing';

class SocAndBalancingStore {
  @observable socAndBalancing: SocAndBalancing[] = [];
  @observable version: number = Date.now();

  @action setSocAndBalancingData = (data: SimpleObject[]) => {
    this.socAndBalancing = data as SocAndBalancing[];
    this.version = Date.now();
  };

  constructor() {
    makeObservable(this);
  }
}

export default SocAndBalancingStore;
